import { TeacherManagementInvitingPage } from './TeacherManagementInvitingPage';
export default TeacherManagementInvitingPage;
